const formatHistoryDateTime = (value) => {
  if (!value) return "";
  return new Date(value).toLocaleString("en-AU");
};

const readHistoryValue = (row = {}, keys = []) => {
  for (const key of keys) {
    if (row[key] !== undefined && row[key] !== null && row[key] !== "") {
      return row[key];
    }
  }
  return "";
};

export default function WorkflowHistoryTimeline({ rows = [], loading = false, error = "", isAdmin = false, emptyMessage = "No workflow history is available yet." }) {
  if (loading) return <div className="text-sm text-slate-500">Loading workflow history...</div>;
  if (error) return <div className="text-sm text-rose-600">{error}</div>;
  if (!rows.length) return <div className="text-sm text-slate-500">{emptyMessage}</div>;

  return (
    <ol className="space-y-4 border-l-2 border-slate-200 pl-5">
      {rows.map((row, index) => {
        const key = readHistoryValue(row, ["studentCourseStepProgressLogNo", "StudentCourseStepProgressLogNo", "studentUSIWFSLogNo", "StudentUSIWFSLogNo", "wfsLogNo", "WFSLogNo"]) || `${readHistoryValue(row, ["actionDt", "ActionDt", "logDt", "LogDt"])}-${index}`;
        const isCurrent = Boolean(readHistoryValue(row, ["isCurrent", "IsCurrent"]));
        const status = readHistoryValue(row, ["workFlowStatusName", "WorkFlowStatusName", "usiStatusName", "USIStatusName", "stepStatus", "StepStatus"]) || "Workflow updated";
        const previousStatus = readHistoryValue(row, ["prevWorkFlowStatusName", "PrevWorkFlowStatusName", "prevUSIStatusName", "PrevUSIStatusName", "prevStepStatus", "PrevStepStatus"]);
        const changedBy = readHistoryValue(row, ["changedBy", "ChangedBy", "actionBy", "ActionBy"]) || "Gippsland Institute of Technology";
        const changedDt = readHistoryValue(row, ["logDt", "LogDt", "actionDt", "ActionDt"]);
        const remarks = readHistoryValue(row, ["remarks", "Remarks", "adminComments", "AdminComments", "rejectedReason", "RejectedReason"]);

        return (
          <li key={key} className="relative">
            <span className={`absolute -left-[1.72rem] top-1 h-3 w-3 rounded-full ${isCurrent ? "bg-orange-500 ring-4 ring-orange-100" : "bg-slate-300"}`} />
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-semibold text-[#0A2540]">{status}</span>
              {isCurrent && <span className="rounded-full bg-orange-100 px-2 py-0.5 text-xs font-semibold text-orange-700">Current</span>}
              {changedDt && <span className="text-xs text-slate-500">{formatHistoryDateTime(changedDt)}</span>}
            </div>
            {isAdmin && <div className="mt-1 text-sm text-slate-600">{previousStatus ? `${previousStatus} -> ${status}` : "Starting status"}</div>}
            {remarks && <div className="mt-1 text-sm text-slate-600">Remarks: {remarks}</div>}
            <div className="mt-1 text-xs text-slate-500">Done by {changedBy}</div>
          </li>
        );
      })}
    </ol>
  );
}
